import {FmlxTooltip} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import './ProtocolTooltipWrapper.scss';
import {useSelector} from 'react-redux';
import {getProtocolExplorerItemOwner, protocolExplorerHelper} from 'lib/explorerHelper';
import {getIsOperator, getSessionUser} from 'stores/selectors/sessionSelectors';
import {ProtocolExplorerAccordionGroup} from 'constants/protocolExplorerEnum';

function ProtocolProperties({title, type, owner, path}) {
  return (
    <div className="protocol-explorer-tooltip">
      <p>
        Name :&nbsp;
        {title}
      </p>
      <p className="content-type">
        Type :&nbsp;
        {type}
      </p>
      {owner ? (
        <p>
          Owner :&nbsp;
          {owner}
        </p>
      ) : (
        ''
      )}
      {path ? (
        <p>
          Path :&nbsp;
          {path}
        </p>
      ) : (
        ''
      )}
    </div>
  );
}

ProtocolProperties.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  owner: PropTypes.string,
  path: PropTypes.string,
};

ProtocolProperties.defaultProps = {
  owner: null,
  path: null,
};

export default function ProtocolTooltipWrapper({item, placement, children, className}) {
  const {userId} = useSelector(getSessionUser);
  const isOperator = useSelector(getIsOperator);
  const protocolOwner = getProtocolExplorerItemOwner(item);

  const {name: ownerName, userId: ownerId} = protocolOwner;
  const {name: tooltipTitle, type, groupView} = item;
  const itemRawData = item[type];

  const isSharedProtocol = ownerId !== userId;
  const isShowOwner = isOperator || isSharedProtocol;
  const isShowPath = groupView === ProtocolExplorerAccordionGroup.FAVORITE_PROTOCOLS;

  const shownOwnerName = isOperator && !isSharedProtocol ? 'You' : ownerName;
  const path = isShowPath ? protocolExplorerHelper.getItemPath(itemRawData.protocolFolderLineages) : null;

  return (
    <FmlxTooltip
      title={
        <ProtocolProperties title={tooltipTitle} type={type} owner={isShowOwner ? shownOwnerName : null} path={path} />
      }
      placement={placement}
      id="protocol-explorer-tooltip"
    >
      <div className={className}>{children}</div>
    </FmlxTooltip>
  );
}
ProtocolTooltipWrapper.propTypes = {
  placement: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  item: PropTypes.object,
};

ProtocolTooltipWrapper.defaultProps = {
  placement: 'bottom',
  className: '',
  children: null,
  item: {},
};
